const tenantIdProd = '5469564'

const config = () => ({
  dlApiScriptFetchUrl:
    'https://lib.onet.pl/s.csr/build/dlApi/dl.boot.dlapi.min.js',
  dlApiUrl: 'https://lib.onet.pl/s.csr/build/dlApi/dl.boot.min.js',
  tenant: 'blick_ch',
  tenant___romandie: 'blick_ch_fr',
  tenantId: tenantIdProd,
  cmpLang: 'de-DE',
  cmpLang___romandie: 'fr-FR',
  adsNoBanner: 0,
  no_gemius: 1,
  async: 1,
  noDfp: 1,
  cmd: [],
})

export type configType = ReturnType<typeof config>
export default config
